import { Typography, useTheme } from "@mui/material";
import { RootState } from "core/store/store.types";
import i18n from "i18n";
import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";

interface OwnProps {}
interface StateProps {}
interface DispatchProps {}
export type Props = OwnProps & StateProps & DispatchProps;

const SubscriptionPlan: FunctionComponent<Props> = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const linguaCorrente = i18n.language;

  return (
    <div>
      <Typography variant="h2" textTransform={"uppercase"} fontWeight={"800"}>
        {t("policies.therms-page.title")}
      </Typography>
      <p>&nbsp;</p>
      <Typography textAlign={"right"}>
        {t("policies.therms-page.last-edit")}
      </Typography>
      <p>&nbsp;</p>
      {linguaCorrente === "it" ? (
        <div style={{ textAlign: "justify" }}>
          <p>
            Le presenti condizioni d’uso (da adesso anche i “Termini di
            utilizzo” o “Condizioni d’uso”) hanno lo scopo di regolare il
            rapporto di licenza “Software as a Service” “SaaS” tra CoDe RTD Srl
            p.iva 12344560011, con sede in Torino (TO) Corso Castelfidardo 30/A,
            CAP 10129 (di seguito “Società”) e i propri clienti (di seguito
            “Clienti”), ed in particolare l’uso del tool Mia Reputation in grado
            di ricercare contenuti condivisi online che violino il diritto
            d’autore e gli altri diritti connessi al suo esercizio.&nbsp;
          </p>
          <p>
            I Clienti che fanno uso o tentano di utilizzare il
            tool&nbsp;Mia Reputation&nbsp;ricevono i connessi servizi (come di
            seguito definiti) confermano di aver letto questo documento e di
            accettare i presenti Termini di utilizzo, inclusi i termini
            dell’Informativa sulla privacy{" "}
            <a
              href="https://www.iubenda.com/privacy-policy/30385171"
              style={{ color: theme.palette.primary.main }}
            >
              https://www.iubenda.com/privacy-policy/30385171
            </a>
            &nbsp;nonché l’offerta commerciale presente sul sito web.
          </p>
          <p>
            La Società si riserva il diritto di aggiornare e/o modificare
            unilateralmente i seguenti Termini di utilizzo, inclusa
            l’Informativa sulla privacy. Gli aggiornamenti e le modifiche ai
            Termini di utilizzo entreranno in vigore immediatamente e le
            relative notifiche appariranno sul sito web&nbsp;
            <a
              href="http://www.codertd.com/"
              style={{ color: theme.palette.primary.main }}
            >
              www.codertd.com
            </a>
            &nbsp;e/o saranno inviate agli indirizzi e-mail dei Clienti che
            hanno acconsentito a ricevere e-mail dalla Società e che hanno
            comunicato i propri recapiti alla Società.&nbsp;
          </p>
          <p>
            I Termini di utilizzo attualmente applicabili sono pubblicati sul
            sito web sotto il link “Termini e condizioni”
            nel&nbsp;footer&nbsp;del sito web.
          </p>
          <p>
            L’utilizzo del tool&nbsp;Mia Reputation&nbsp;o la ricezione dei
            servizi costituiscono implicito accordo rispetto ai Termini di
            utilizzo così come di volta in volta aggiornati e/o modificati dalla
            Società e presenti sul sito web.
          </p>
          <p>
            I Clienti sono tenuti a contattare la Società in merito a qualsiasi
            questione inerente ai presenti Termini di utilizzo, inviando una
            mail al seguente indirizzo info@codertd.com
          </p>
          <p>&nbsp;</p>
          <p>1. Definizioni e disposizioni generali</p>
          <>
            <p style={{ paddingLeft: "40px" }}>
              I titoli dei singoli articoli e delle sezioni che seguono sono
              forniti esclusivamente per comodità e non devono o possono essere
              considerati ai fini dell’interpretazione delle presenti Condizioni
              d’uso o della loro validità.
            </p>
            <p style={{ paddingLeft: "40px" }}>
              Definizioni. Ai fini delle presenti Condizioni d’uso, ai seguenti
              termini, salvo diversa indicazione esplicita, saranno attribuiti i
              seguenti significati:
            </p>
            <ol type="a" style={{ paddingLeft: "40px" }}>
              <li>“Società”: si intende CoDe RTD S.r.l.</li>
              <li>
                “Servizi” o “Software”: si intende il tool Mia Reputation che
                consente di ricercare i contenuti condivisi online, su
                determinate piattaforme, che violano il diritto d’autore e gli
                altri diritti connessi al suo esercizio e di elaborare un
                apposito report, che verrà fornito ai clienti, contenente i
                risultati della ricerca.
              </li>
              <li>
                “Report”: è il documento riportante i risultati della ricerca
                effettuata mediante il Tool, anche certificati dall’utilizzo
                della blockchain.
              </li>
              <li>
                “Cliente”: chiunque acquisti una licenza per l’utilizzo dei
                Servizi (i) ai fini dell’uso personale del Software; (ii) per un
                soggetto terzo (persona fisica o giuridica) che utilizzerà il
                software per conto del Cliente (se consentito dalla Società per
                iscritto).
              </li>
              <li>
                “Litigation Support” si intende il servizio di consulenza che la
                Società può offrire ai propri Clienti, a seconda del pacchetto
                da questi ultimi acquistato, per contestare l’avvenuta
                violazione del diritto d’autore da parte di terzi.
              </li>
              <li>
                “Licenza”: una licenza software “Saas” rilasciata dalla Società
                per ogni Cliente.
              </li>
              <li>
                “Pacchetto”: si intende la singola offerta commerciale dei
                Servizi della Società volti all’utilizzo del Software.
              </li>
              <li>
                “Sito Web” indica il sito web della Società reperibile
                all’indirizzo https://www.codertd.com
              </li>
              <li>
                “Server”: si intendono i server necessari per il funzionamento
                del Tool situati all’interno dell’UE
              </li>
            </ol>
          </>
          <p>&nbsp;</p>
          <p>2. Utilizzo dei Servizi forniti da CoDe RTD</p>
          <>
            <ol style={{ paddingLeft: "40px" }}>
              <li>
                La Licenza e il relativo utilizzo dei Servizi possono avvenire
                da parte del Cliente esclusivamente in conformità alle regole
                qui di seguito stabilite. L’utilizzo dei Servizi deve essere
                effettuato solo come stabilito nelle presenti Condizioni d’uso,
                a meno che non si ottenga il previo consenso scritto della
                Società.
              </li>
              <li>
                Quando si utilizza il software, non è possibile rappresentare
                altra persona fisica o giuridica (società) diversa dal Cliente.
              </li>
              <li>
                Non è possibile: (i) copiare, modificare, creare opere derivate
                del Software; o (ii) assemblare, decompilare, decodificare o
                tentare in altro modo di influenzare o derivare il codice
                sorgente del Software (o le idee, gli algoritmi, la struttura o
                l’organizzazione sottostanti).
              </li>
              <li>
                Il Cliente non può violare o compromettere, in alcun modo, alcun
                diritto di proprietà intellettuale esistente nel Software,
                inclusi, a titolo esemplificativo, copyright, brevetti, marchi o
                qualsiasi altro diritto appartenente alla Società o a terzi.
              </li>
              <li>
                Non è possibile utilizzare il Software in modo contrario o
                incoerente rispetto ai presenti Termini di utilizzo, né (senza
                deroga alla generalità di quanto sopra), in alcun modo che sia
                illegale, immorale o contrario all’ordine pubblico.
              </li>
            </ol>
          </>
          <p>&nbsp;</p>
          <p>3. Acquisto della Licenza, pagamento del prezzo e durata&nbsp;</p>
          <>
            <ol style={{ paddingLeft: "40px" }}>
              <li>
                Al momento dell’acquisto di un Pacchetto, il Cliente accetta e
                conferma di aver sottoscritto un accordo di licenza “Software as
                a Service” (“SaaS”), in base al quale utilizzerà i Servizi in
                conformità con i presenti Termini di utilizzo. Il Cliente non
                sta acquistando il Software o qualsiasi parte di esso, incluso,
                senza limitazione, il codice e/o file di supporto e/o database
                e/o qualsiasi altro componente del software che, congiuntamente
                o separatamente, compongono lo stesso.
              </li>
              <li>
                Il Software è utilizzabile da parte dei Clienti tramite i
                principali browser. Al fine di sfruttare nel modo migliore tutte
                le funzionalità, è consigliato l’utilizzo del browser Chrome.
              </li>
              <li>
                La Licenza viene acquistata tramite il Sito Web o tramite la
                Società, utilizzando i mezzi di pagamento disponibili sul Sito
                Web alla data di acquisto, se applicabile.
              </li>
              <li>
                Il pagamento del prezzo del Pacchetto avviene al momento
                dell’acquisto. Il Pacchetto può essere acquistato su base
                mensile e si rinnova automaticamente a meno che il Cliente non
                comunichi la disdetta alla Società inviando comunicazione
                scritta che deve essere ricevuta dalla Società almeno 10 giorni
                prima della scadenza, fatto salvo il diritto di recesso di cui
                al successivo art. 3 punto 8.
              </li>
              <li>
                Al momento dell’acquisto del Pacchetto Entreprise, il Cliente
                sarà tenuto al pagamento dei Costi di Implementazione.
              </li>
              <li>
                La Società si riserva il diritto di sostituire e /o modificare,
                di volta in volta, i mezzi di pagamento disponibili sul Sito
                Web, nonché di aggiornare il prezzo dei Pacchetti: in caso di
                modifiche al prezzo della Licenza il Cliente riceverà apposita
                comunicazione e avrà la facoltà di recedere inviando
                comunicazione scritta che deve essere ricevuta dalla Società
                almeno 7 giorni prima dal primo rinnovo con i prezzi aggiornati.
                Nel caso in cui il Cliente non receda dal Servizio, si intenderà
                avere accettato i nuovi prezzi del Pacchetto comunicati.
              </li>
              <li>
                L’ordine può essere annullato dal Cliente entro 14 giorni
                dall’invio dell’ordine di acquisto, salvo eventuali spese o
                costi di recesso ai sensi della legge applicabile. Per annullare
                l’ordine il Cliente deve inviare un’e-mail all’indirizzo
                info@codertd.com indicando le proprie informazioni
                identificative (nome e cognome, denominazione o ragione sociale,
                C.F. e/o P.IVA) e una copia della ricevuta dell’ordine
                effettuato.
              </li>
              <li>
                Il Cliente può recedere in qualsiasi momento dal contratto,
                previo pagamento di tutte le somme dovute alla Società per tutto
                il periodo di Licenza concesso.
                <br /> Il recesso sarà efficace al termine del mese di invio
                della comunicazione, laddove la stessa pervenga entro il giorno
                quindici del mese; nel caso in cui la comunicazione pervenga
                dopo tale data il recesso sarà efficace alla fine del mese
                successivo.
              </li>
              <li>
                La Società si riserva il diritto di trasferire i propri diritti
                e obblighi ai sensi dei presenti Termini di utilizzo a terzi, a
                condizione che i diritti del Cliente non siano influenzati
                negativamente.
              </li>
              <li>
                La Società si riserva il diritto di terminare l’ordine e/o in
                qualsiasi momento, senza giustificazione al Cliente, fornendo al
                Cliente un preavviso di 30 giorni, ove possibile. Nel caso in
                cui la Società risolva il rapporto relativo al Pacchetto
                sottoscritto, la Società rimborserà il Cliente di parte del
                corrispettivo speso per il Pacchetto, a seconda e in proporzione
                della durata residua di validità che la Licenza avrebbe
                originariamente avuto.
              </li>
            </ol>
          </>
          <p>&nbsp;</p>
          <p>4. Malfunzionamenti; Problemi</p>
          <>
            <ol style={{ paddingLeft: "40px" }}>
              <li>
                Qualora il Cliente comunichi alla Società un avviso in merito a
                un errore dalle disposizioni del Servizio, la Società agirà al
                meglio delle proprie capacità per correggere tale errore. In
                ogni caso, la Società si impegna a ripristinare la corretta
                funzionalità del Servizio nell’ambito delle capacità tecniche
                del Software.
              </li>
              <li>
                La Società concede esclusivamente ai Clienti, durante il normale
                orario lavorativo (dal lunedì al venerdì dalle 10:00 alle 18:00)
                e tramite e-mail, servizi di supporto tecnico quali, a titolo
                esemplificativo e non esaustivo, l’assistenza nel funzionamento
                del Software, le soluzioni ai malfunzionamenti dello stesso,
                l’assistenza nell’uso dell’account personale del Cliente,
                questioni tecniche e operative relative ai pagamenti e/o
                all’acquisto della Licenza o, in generale, alla conclusione di
                ordini.
              </li>
              <li>
                La Società farà del suo meglio per risolvere i malfunzionamenti
                nel Software nel minor tempo possibile.
              </li>
            </ol>
          </>
          <p>&nbsp;</p>
          <p>5. Limitazione di responsabilità; Responsabilità del cliente</p>
          <>
            <ol style={{ paddingLeft: "40px" }}>
              <li>
                Tutte le limitazioni di responsabilità della Società di seguito
                indicate, così come le clausole che limitano indennizzi o
                producono un effetto giuridicamente equivalente ad una
                limitazione di responsabilità della Società, sono valide ed
                efficaci fatte salve eventuali disposizioni di legge
                inderogabili, come ad esempio nel caso di dolo o colpa grave,
                anche nel caso in cui questo non venga espressamente indicato.
              </li>
              <li>
                La Società non fornisce alcun impegno, dichiarazione o garanzia
                non specificati nei presenti Termini di utilizzo.
              </li>
              <li>
                La Società si riserva la facoltà di aggiornare a propria
                discrezione il Software con conseguente possibile interruzione
                temporanea nella fornitura dei Servizi. La Società non ha alcun
                controllo sui malfunzionamenti che possono verificarsi, di volta
                in volta, in relazione alla disponibilità dei servizi inclusi
                nel Software, né sui servizi forniti da terze parti.
              </li>
              <li>
                Il Cliente è consapevole che il Sito Web, tutte le comunicazioni
                con i rappresentanti della Società e il Report non costituiscono
                fornitura di consulenza legale.
              </li>
              <li>
                Il Cliente è consapevole che il Geo-Blocking potrebbe impedire
                il corretto funzionamento del Software. Per “Geo-Blocking” si
                intende: (i) il Sito Internet di un Cliente non raggiungibile da
                determinate posizioni geografiche; o (ii) il Sito Internet di un
                Cliente che reindirizza a un sito web diverso in base alla
                posizione dell’utente che vi accede.
              </li>
              <li>
                È responsabilità del Cliente verificare, prima di utilizzare il
                Software, che i sistemi siano compatibili con i propri
                dispositivi e/o database.
              </li>
              <li>
                Fermo restando quanto precede, e salve disposizioni inderogabili
                di legge come in caso di dolo o colpa grave, il Cliente accetta
                che, in ogni caso e in relazione al Software, la responsabilità
                della Società nei suoi confronti sarà limitata ad una somma non
                superiore ai pagamenti complessivi effettuati dal Cliente alla
                Società in relazione ai Servizi offerti.
              </li>
              <li>
                Inoltre, e senza derogare a quanto sopra detto, il Cliente dovrà
                tenere indenne la Società per qualsiasi somma che la Società
                dovesse sopportare e/o fosse tenuta a sostenere per
                responsabilità del Cliente, quali le spese legali, commissioni e
                altri costi.
              </li>
              <li>
                Il Cliente esonera da qualsiasi responsabilità la Società nel
                caso di utilizzo improprio del Report da parte sua o di terze
                parti che ne vengano a conoscenza.
              </li>
            </ol>
          </>
          <p>&nbsp;</p>
          <p>6. Proprietà intellettuale</p>
          <>
            <ol style={{ paddingLeft: "40px" }}>
              <li>
                I diritti di proprietà intellettuale, inclusi i diritti d’autore
                e i marchi (se esistenti) nel Software, appartengono
                esclusivamente alla Società. Il Cliente, pertanto, non ha il
                diritto di copiare, distribuire, mostrare pubblicamente,
                eseguire pubblicamente, comunicare al pubblico, modificare,
                elaborare, creare derivati, vendere o dare in leasing qualsiasi
                parte di essi, da solo o in collaborazione con terze parti, con
                qualsiasi modalità o utilizzando qualsiasi mezzo elettronico,
                meccanico o ottico, utilizzando mezzi fotografici o di
                registrazione, o attraverso qualsiasi altro mezzo, senza il
                previo consenso scritto della Società e/o degli altri titolari
                dei diritti. Questa disposizione è valida anche in relazione a
                qualsiasi elaborazione, modifica o traduzione eseguita dalla
                Società sui contenuti forniti o messi a disposizione dal
                Cliente. I database, i software, i codici, i sistemi e le
                applicazioni, i file grafici, i file multimediali e audio, gli
                elaborati scritti e gli altri materiali, inclusi i disegni e le
                grafiche, collegati a vario titolo ai diritti di proprietà
                industriale e al diritto d’autore della Società, appartengono
                alla stessa Società che ne detiene i diritti esclusivi e/o ai
                suoi danti causa.
              </li>
              <li>
                Il Cliente non ha il diritto e non avrà il diritto di utilizzare
                il Software o qualsiasi parte di essi in modo tale da violare le
                disposizioni dei presenti Termini di utilizzo, o che possa
                ledere i diritti della Società e/o i diritti di qualsiasi parte
                terza, utilizzando qualsiasi mezzo, digitale o altro, senza il
                preventivo consenso scritto della Società.
              </li>
              <li>
                I marchi e i messaggi pubblicitari degli inserzionisti nel
                Software e/o sul Sito Web sono di proprietà esclusiva di tali
                inserzionisti. Senza derogare ai divieti di cui sopra, non può
                essere fatto alcun uso neppure di questi, senza previo consenso
                scritto.
              </li>
              <li>
                Il Cliente dà il proprio consenso affinché la Società possa
                rendere pubblico e divulgare – sia a fini informativi che
                promozionali – il fatto che la Società ha fornito e / o fornisce
                i Servizi al Cliente e che il Software è utilizzato dal Cliente.
                Il Cliente riconosce inoltre il diritto della Società di
                utilizzare, senza limitazioni territoriali (e quindi in tutto il
                mondo) per finalità di marketing e pubblicitarie della Società,
                la denominazione o ragione sociale e i segni distintivi (ivi
                inclusi i loghi e il nome a dominio) del Cliente in quanto fa o
                ha fatto parte del suo portfolio clienti.
              </li>
              <li>
                Le disposizioni della presente clausola sulla proprietà
                intellettuale si applicano nonostante la cessazione della
                fornitura dei Servizi alla conclusione del periodo del
                Pacchetto, per qualsiasi motivo essa avvenga.
              </li>
              <li>
                In caso di violazione di una o più norme del presente articolo,
                la Società si riserva di agire per il risarcimento dei danni
                patiti.
              </li>
              <li>
                Le disposizioni della presente sezione non derogano alle
                disposizioni di alcuna legge o ai diritti conferiti alla Società
                dalla legge.
              </li>
            </ol>
          </>
          <p>&nbsp;</p>
          <p>7.&nbsp;Cessazione dei Servizi</p>
          <>
            <ol style={{ paddingLeft: "40px" }}>
              <li>
                La Società può, a propria discrezione e senza preavviso,
                limitare o interrompere l’accesso di un Cliente al Software e ai
                Servizi e rifiutarsi di fornirgli tale accesso, in ciascuno dei
                seguenti casi (salvo il risarcimento degli eventuali danni e
                ogni ulteriore rimedio, iniziativa o azione concessa alla
                Società dalla legge):
                <ol style={{ paddingLeft: "40px" }}>
                  <li>se un Cliente viola i presenti Termini di utilizzo;</li>
                  <li>
                    se la Società ritiene ragionevolmente che l’utilizzo da
                    parte del Cliente del Software e/o dei Servizi possa essere
                    causa di danni economici e/o frodi di qualsiasi tipo e/o
                    solleva preoccupazioni in merito; o
                  </li>
                  <li>
                    Se la Società ritiene ragionevolmente che le azioni di un
                    Cliente possano causare un danno economico e/o cagionare una
                    responsabilità di qualsivoglia natura per la Società nei
                    confronti di soggetti terzi.
                  </li>
                </ol>
              </li>
            </ol>
          </>
          <p>&nbsp;</p>
          <p>8. Legge applicabile e giurisdizione esclusiva&nbsp;</p>
          <>
            <p style={{ paddingLeft: "40px" }}>
              I presenti Termini di utilizzo sono soggetti esclusivamente alla
              legge italiana.
            </p>
            <p style={{ paddingLeft: "40px" }}>
              Il Tribunale di Torino ha la competenza esclusiva per qualsiasi
              controversia derivante dalla licenza e dai presenti Termini di
              utilizzo.
            </p>
          </>
        </div>
      ) : (
        <div style={{ textAlign: "justify" }}>
          <p>
            These terms of use (hereinafter also referred to as "Terms of Use"
            or "Conditions of Use") are intended to regulate the "Software as a
            Service" "SaaS" license relationship between CoDe RTD Srl VAT
            12344560011, based in Turin (TO) Corso Castelfidardo 30/A, ZIP 10129
            (hereinafter "Company") and its customers (hereinafter "Customers"),
            and in particular the use of the Mia Reputation tool capable of
            searching for online content that violates copyright and other
            rights connected to its exercise.&nbsp;
          </p>
          <p>
            Customers who use or attempt to use the Mia Reputation
            tool&nbsp;receive the related services (as defined below) confirm
            having read this document and accept these Terms of Use, including
            the terms of the Privacy Policy&nbsp;
            <a
              href="https://www.iubenda.com/privacy-policy/30385171"
              style={{ color: theme.palette.primary.main }}
            >
              https://www.iubenda.com/privacy-policy/30385171
            </a>
            &nbsp;as well as the commercial offer present on the website.
          </p>
          <p>
            The Company reserves the right to unilaterally update and/or modify
            these Terms of Use, including the Privacy Policy. Updates and
            changes to the Terms of Use will take effect immediately and related
            notifications will appear on the website&nbsp;
            <a
              href="http://www.codertd.com/"
              style={{ color: theme.palette.primary.main }}
            >
              www.codertd.com
            </a>
            &nbsp;and/or will be sent to the email addresses of Customers who
            have consented to receive emails from the Company and who have
            communicated their contact details to the Company.&nbsp;
          </p>
          <p>
            The currently applicable Terms of Use are published on the website
            under the link “Terms and conditions” in the&nbsp;footer&nbsp;of the
            website.
          </p>
          <p>
            Using the Mia Reputation tool&nbsp;or receiving the services
            constitutes implicit agreement with the Terms of Use as updated
            and/or modified by the Company and present on the website.
          </p>
          <p>
            Customers are required to contact the Company regarding any issues
            related to these Terms of Use, by sending an email to the following
            address info@codertd.com
          </p>
          <p>&nbsp;</p>
          <p>1. Definitions and general provisions</p>
          <>
            <p style={{ paddingLeft: "40px" }}>
              The titles of the individual articles and the following sections
              are provided solely for convenience and must not or cannot be
              considered for the interpretation of these Conditions of Use or
              their validity.
            </p>
            <p style={{ paddingLeft: "40px" }}>
              Definitions. For the purposes of these Conditions of Use, the
              following terms, unless otherwise explicitly indicated, will be
              assigned the following meanings:
            </p>
            <ol type="a" style={{ paddingLeft: "40px" }}>
              <li>“Company”: refers to CoDe RTD S.r.l.</li>
              <li>
                “Services” or “Software”: refers to the Mia Reputation tool that
                allows for the search of online content, on specific platforms,
                that violates copyright and other rights connected to its
                exercise and to compile a special report, which will be provided
                to customers, containing the results of the search.
              </li>
              <li>
                “Report”: is the document reporting the results of the search
                carried out through the Tool, also certified by the use of
                blockchain.
              </li>
              <li>
                “Customer”: anyone who purchases a license for the use of
                Services (i) for personal use of the Software; (ii) for a third
                party (individual or legal entity) who will use the software on
                behalf of the Customer (if allowed by the Company in writing).
              </li>
              <li>
                “Litigation Support” refers to the consultancy service that the
                Company can offer to its Customers, depending on the package
                purchased by them, to contest the occurred violation of
                copyright by third parties.
              </li>
              <li>
                “License”: a “SaaS” software license issued by the Company for
                each Customer.
              </li>
              <li>
                “Package”: refers to the individual commercial offer of the
                Company's Services aimed at the use of the Software.
              </li>
              <li>
                “Website” indicates the Company's website accessible at
                https://www.codertd.com
              </li>
              <li>
                “Servers”: refers to the servers necessary for the operation of
                the Tool located within the EU
              </li>
            </ol>
          </>
          <p>&nbsp;</p>
          <p>2. Use of Services provided by CoDe RTD</p>
          <>
            <ol style={{ paddingLeft: "40px" }}>
              <li>
                The License and the related use of Services can occur on the
                part of the Customer exclusively in accordance with the rules
                set forth hereafter. The use of Services must be carried out
                only as established in these Conditions of Use, unless prior
                written consent is obtained from the Company.
              </li>
              <li>
                When using the software, it is not possible to represent another
                individual or legal entity (company) other than the Customer.
              </li>
              <li>
                It is not possible to: (i) copy, modify, create derivative works
                of the Software; or (ii) assemble, decompile, decode, or
                otherwise attempt to influence or derive the source code of the
                Software (or the ideas, algorithms, structure, or organization
                underlying it).
              </li>
              <li>
                The Customer cannot violate or compromise, in any way, any
                existing intellectual property right in the Software, including,
                for example, copyright, patents, trademarks, or any other right
                belonging to the Company or third parties.
              </li>
              <li>
                It is not possible to use the Software in a manner contrary or
                inconsistent with these Terms of Use, nor (without derogating
                from the generality of the foregoing), in any way that is
                illegal, immoral, or contrary to public order.
              </li>
            </ol>
          </>
          <p>&nbsp;</p>
          <p>3. Purchase of License, payment of price, and duration&nbsp;</p>
          <>
            <ol style={{ paddingLeft: "40px" }}>
              <li>
                At the time of purchasing a Package, the Customer agrees and
                confirms to have signed a “Software as a Service” (“SaaS”)
                license agreement, under which they will use the Services in
                accordance with these Terms of Use. The Customer is not
                purchasing the Software or any part of it, including, without
                limitation, the code and/or support files and/or database and/or
                any other component of the software that, jointly or separately,
                make it up.
              </li>
              <li>
                The Software can be used by Customers through the main browsers.
                To best exploit all functionalities, the use of the Chrome
                browser is recommended.
              </li>
              <li>
                The License is purchased through the Website or through the
                Company, using the payment methods available on the Website at
                the date of purchase, if applicable.
              </li>
              <li>
                The payment for the Package occurs at the time of purchase. The
                Package can be purchased on a monthly basis and automatically
                renews unless the Customer communicates the cancellation to the
                Company by sending written communication that must be received
                by the Company at least 10 days before the expiration,
                notwithstanding the right of withdrawal as per the following
                art. 3 point 8.
              </li>
              <li>
                At the time of purchasing the Entreprise Package, the Customer
                will be required to pay the Implementation Costs.
              </li>
              <li>
                The Company reserves the right to replace and/or modify, from
                time to time, the payment methods available on the Website, as
                well as to update the price of the Packages: in case of changes
                to the price of the License the Customer will receive a specific
                communication and will have the ability to withdraw by sending
                written communication that must be received by the Company at
                least 7 days before the first renewal with the updated prices.
                If the Customer does not withdraw from the Service, it will be
                deemed to have accepted the new Package prices communicated.
              </li>
              <li>
                The order can be canceled by the Customer within 14 days from
                sending the purchase order, except for any expenses or
                withdrawal costs pursuant to applicable law. To cancel the order
                the Customer must send an email to info@codertd.com indicating
                their identification information (name and surname, company
                name, VAT number) and a copy of the order receipt.
              </li>
              <li>
                The Customer can withdraw from the contract at any time, upon
                payment of all sums due to the Company for the entire License
                period granted. The withdrawal will be effective at the end of
                the month of sending the communication, where the same arrives
                within the fifteenth day of the month; if the communication
                arrives after this date, the withdrawal will be effective at the
                end of the following month.
              </li>
              <li>
                The Company reserves the right to transfer its rights and
                obligations under these Terms of Use to third parties, provided
                that the Customer's rights are not negatively affected.
              </li>
              <li>
                The Company reserves the right to terminate the order and/or at
                any time, without justification to the Customer, providing the
                Customer with a 30-day notice, where possible. In the case that
                the Company terminates the relationship related to the
                subscribed Package, the Company will refund the Customer part of
                the amount spent for the Package, depending on and in proportion
                to the remaining validity period that the License would have
                originally had.
              </li>
            </ol>
          </>
          <p>&nbsp;</p>
          <p>4. Malfunctions; Issues</p>
          <>
            <ol style={{ paddingLeft: "40px" }}>
              <li>
                Should the Customer notify the Company of an error in the
                Service provisions, the Company will act to the best of its
                ability to correct such error. In any case, the Company commits
                to restoring the correct functionality of the Service within the
                technical capabilities of the Software.
              </li>
              <li>
                The Company exclusively provides Customers, during normal
                working hours (Monday to Friday from 10:00 AM to 6:00 PM) and
                via email, technical support services such as, by way of example
                and not exhaustive, assistance in the operation of the Software,
                solutions to its malfunctions, assistance in using the personal
                account of the Customer, technical and operational issues
                related to payments and/or the purchase of the License or, in
                general, the conclusion of orders.
              </li>
              <li>
                The Company will do its best to resolve malfunctions in the
                Software as quickly as possible.
              </li>
            </ol>
          </>
          <p>&nbsp;</p>
          <p>5. Limitation of liability; Customer's liability</p>
          <>
            <ol style={{ paddingLeft: "40px" }} type="a">
              <li>
                All limitations of the Company's liability indicated below, as
                well as clauses that limit compensations or produce a legally
                equivalent effect to a limitation of the Company's liability,
                are valid and effective notwithstanding any mandatory legal
                provisions, such as in the case of intentional misconduct or
                gross negligence, even if this is not expressly stated.
              </li>
              <li>
                The Company does not provide any commitment, declaration, or
                warranty not specified in these Terms of Use.
              </li>
              <li>
                The Company reserves the right to update the Software at its
                discretion, with a possible temporary interruption in the
                provision of Services. The Company has no control over
                malfunctions that may occur, from time to time, in relation to
                the availability of services included in the Software, nor on
                services provided by third parties.
              </li>
              <li>
                The Customer is aware that the Website, all communications with
                the representatives of the Company, and the Report do not
                constitute provision of legal advice.
              </li>
              <li>
                The Customer is aware that Geo-Blocking might prevent the
                correct functioning of the Software. For “Geo-Blocking” it
                means: (i) a Customer's Website not accessible from certain
                geographical locations; or (ii) a Customer's Website that
                redirects to a different website based on the user's access
                location.
              </li>
              <li>
                It is the Customer's responsibility to verify, before using the
                Software, that the systems are compatible with their devices
                and/or database.
              </li>
              <li>
                Notwithstanding the foregoing, and save for mandatory legal
                provisions such as in the case of intentional misconduct or
                gross negligence, the Customer agrees that, in any case and in
                relation to the Software, the Company's liability towards them
                will be limited to an amount not exceeding the total payments
                made by the Customer to the Company in relation to the Services
                offered.
              </li>
              <li>
                Furthermore, and without derogating from the above, the Customer
                shall indemnify the Company for any sum that the Company may
                have to bear and/or is required to sustain due to the Customer's
                liability, such as legal fees, commissions, and other costs.
              </li>
              <li>
                The Customer exempts the Company from any liability in case of
                improper use of the Report by themselves or third parties who
                become aware of it.
              </li>
            </ol>
          </>
          <p>&nbsp;</p>
          <p>6. Intellectual Property</p>
          <>
            <ol style={{ paddingLeft: "40px" }}>
              <li>
                Intellectual property rights, including copyright and trademarks
                (if existing) in the Software, belong exclusively to the
                Company. Therefore, the Customer does not have the right to
                copy, distribute, publicly display, perform publicly,
                communicate to the public, modify, process, create derivatives,
                sell or lease any part of them, alone or in collaboration with
                third parties, in any manner or using any electronic, mechanical
                or optical means, using photographic or recording means, or
                through any other means, without the prior written consent of
                the Company and/or other rights holders. This provision also
                applies to any processing, modification or translation performed
                by the Company on the content provided or made available by the
                Customer. The databases, software, codes, systems, and
                applications, graphic files, multimedia and audio files, written
                elaborations, and other materials, including designs and
                graphics, related in various ways to industrial property rights
                and copyright of the Company, belong to the same Company which
                holds the exclusive rights and/or to its predecessors in title.
              </li>
              <li>
                The Customer does not have the right and will not have the right
                to use the Software or any part of it in such a way as to
                violate the provisions of these Terms of Use, or that may harm
                the rights of the Company and/or any third party, using any
                means, digital or otherwise, without the prior written consent
                of the Company.
              </li>
              <li>
                The trademarks and advertising messages of advertisers in the
                Software and/or on the Website are the exclusive property of
                such advertisers. Without derogating from the above
                prohibitions, no use of these can be made, without prior written
                consent.
              </li>
              <li>
                The Customer consents for the Company to make public and
                disclose – both for informational and promotional purposes – the
                fact that the Company has provided and/or provides Services to
                the Customer and that the Software is used by the Customer. The
                Customer also recognizes the right of the Company to use,
                without territorial limitations (and therefore worldwide) for
                marketing and advertising purposes of the Company, the name or
                business name and distinctive signs (including logos and domain
                name) of the Customer as part of its client portfolio.
              </li>
              <li>
                The provisions of this clause on intellectual property apply
                notwithstanding the cessation of the provision of Services at
                the end of the Package period, for whatever reason it occurs.
              </li>
              <li>
                In case of violation of one or more rules of this article, the
                Company reserves the right to act for compensation for the
                damages suffered.
              </li>
              <li>
                The provisions of this section do not derogate from the
                provisions of any law or rights conferred on the Company by law.
              </li>
            </ol>
          </>
          <p>&nbsp;</p>
          <p>7.&nbsp;Termination of Services</p>
          <>
            <ol style={{ paddingLeft: "40px" }}>
              <li>
                The Company may, at its discretion and without notice, limit or
                discontinue a Customer's access to the Software and Services and
                refuse to provide such access, in any of the following cases
                (except for compensation for any damages and any further remedy,
                initiative, or action granted to the Company by law):
                <ol style={{ paddingLeft: "40px" }}>
                  <li>if a Customer violates these Terms of Use;</li>
                  <li>
                    if the Company reasonably believes that the use by the
                    Customer of the Software and/or Services may cause financial
                    harm and/or fraud of any kind and/or raises concerns
                    accordingly; or
                  </li>
                  <li>
                    If the Company reasonably believes that the actions of a
                    Customer may cause financial harm and/or incur a liability
                    of any nature for the Company towards third parties.
                  </li>
                </ol>
              </li>
            </ol>
          </>
          <p>&nbsp;</p>
          <p>8. Applicable law and exclusive jurisdiction&nbsp;</p>
          <>
            <p style={{ paddingLeft: "40px" }}>
              These Terms of Use are exclusively subject to Italian law.
            </p>
            <p style={{ paddingLeft: "40px" }}>
              The Court of Turin has exclusive jurisdiction for any dispute
              arising from the license and these Terms of Use.
            </p>
          </>
        </div>
      )}
    </div>
  );
};

export default connect<StateProps, DispatchProps, OwnProps, RootState>(
  (state: RootState) => ({}),
  () => ({})
)(SubscriptionPlan);
